export interface IFilterActeursJuridiquesSearch {
    IdSociete?: number;
    IdActeursJuridiques?: number[];
    SearchLibelle?:string;
    IsDescending?: boolean;
    SortField?: string;
    Limit?: number;
  }


  export const getDefaultFilterActeursJuridiques = (): IFilterActeursJuridiquesSearch => ({
    IdSociete:0,
    IdActeursJuridiques: undefined,
    SearchLibelle: "",
  });
  
  export const filterToQuery = (filter: IFilterActeursJuridiquesSearch): IFilterActeursJuridiquesSearch => {
    const dto: IFilterActeursJuridiquesSearch = {};
 
    if (filter?.IdSociete !== undefined ) {
      dto.IdSociete = filter.IdSociete;
    } 

    if (filter?.IdActeursJuridiques !== undefined ) {
      dto.IdActeursJuridiques = filter.IdActeursJuridiques;
    } 

     if (filter?.SearchLibelle !== "" ) {
      dto.SearchLibelle = filter.SearchLibelle;
    } 
 
    localStorage.setItem("IFilterActeursJuridiquesSearch", JSON.stringify(dto));
  
    return dto;
  };
  
  export const dtoToFilter = (dto: IFilterActeursJuridiquesSearch): IFilterActeursJuridiquesSearch => {
  
    return {
      IdSociete: dto.IdSociete !== undefined ? dto.IdSociete : 0,
      IdActeursJuridiques: dto.IdActeursJuridiques,// !== undefined ? dto.IdActeursJuridiques : undefined,
      SearchLibelle: dto.SearchLibelle !== undefined ? dto.SearchLibelle : "",
    };
  };
 